import { Component, ElementRef, ViewChild } from '@angular/core';
import { PageBase } from 't4core';
import { TerminationDialog } from '../../dialogs/TerminationDialog/TerminationDialog';
import { ContractDialog } from '../../dialogs/ContractDialog/ContractDialog';
import { T4DatatableWidget } from '../../../../t4common/';


@Component({
  selector: 'OffRent',
  templateUrl: './OffRent.html',
})
export class OffRentComponent extends PageBase {
    @ViewChild("tblUnhandled", {static: false}) tblUnhandled: T4DatatableWidget;

    constructor(el: ElementRef) {
        super(el, "Order");
    }

    /// Actions
    public async createTermination() {
        var rows = this.tblUnhandled.data.renderedData.filter(function (n, i) {
            return n.Terminate;
        });

        await this.Dialog.open(TerminationDialog, {
            data: {
                TerminationRows: rows
            }
        }).afterClosed();
        this.tblUnhandled.update();

        return;
    }

    public openContractDialog(vehicleId: string) {
      if (!vehicleId) return;

      ContractDialog.open(this.Dialog, vehicleId);
  }

  public showTermination(tId: number) {
    this.Dialog.open(TerminationDialog, {
      data: {
        TerminationId: tId
      }
    });

    return;
  }
  public async openVehicle(id: string) {
    var dlg = this.Dialog.open(ContractDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "750px",
      data: {
        vehicleId: id
      }
    });

    var changes = await dlg.afterClosed().toPromise();
  }


    public async extend() {
        var rows = this.tblUnhandled.data.renderedData.filter(function (n, i) {
            return n.Terminate;
        });

        if (rows.length > 0) {
            var defaultRow = rows.sort((a, b) => {
                var d1 = a.OffRentDate;
                var d2 = b.OffRentDate;

                if (d1 < d2) return 1;
                return 0;
            })[0];

            var defaultDate = defaultRow.OffRentDate.clone();


            var selectedDate = await this.UI.selectDate(defaultDate.clone().add('month', 3), defaultDate, defaultDate.clone().add('month', 6));
            if (selectedDate) {
                if (selectedDate.date() > 1) selectedDate = selectedDate.startOf('month').add('month', 1);

                var x = await this.UI.confirm("TO.ActiveContracts.headConfirmExtend", "Confirm extension", "TO.ActiveContracts.msgConfirmExtend", "Do you want to extend {0} contracts to {1}", null, [rows.length, selectedDate.format("YYYY-MM-DD")]);
                if (!x) return;

                for (var i of rows) {
                  await this.Api.get<string>("TurboOrder/ExtendContract", { contractId: i.Id, newEndDate: selectedDate });
                }

                this.tblUnhandled.update();
            }
        }
    }

    public anyChecked(): boolean {
        return this.tblUnhandled && this.tblUnhandled.data.renderedData.filter(function (n, i) {
            return n.Terminate;
        }).length > 0;
    }
}
